import { AccountingDistributionExternalActionTypes, AccountingDistributionExternalActions } from './accounting-distribution-external.actions';
import { IAccountingDistributionExternal } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IAccountingDistributionExternal | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: AccountingDistributionExternalActions): State {
    switch (action.type) {

        case AccountingDistributionExternalActionTypes.LoadAccountingDistributionExternalState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case AccountingDistributionExternalActionTypes.LoadAccountingDistributionExternalStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case AccountingDistributionExternalActionTypes.LoadAccountingDistributionExternalStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case AccountingDistributionExternalActionTypes.AccountingDistributionExternalScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;